export enum AI {
    /**
     * @value The AI service is currently experiencing high demand.
     * @description Error message displayed when an AI features fails because of high demands (usually 429 errors)
     */
    AI_SERVICES_EXPERIENCING_HIGH_DEMAND = 'AI.AI_SERVICES_EXPERIENCING_HIGH_DEMAND',
    /**
     * @value Some sources are unavailable because you're not connected to providers. Connect to access all sources.
     * @description Warning displayed when a source used in an Ask AI query needs the user to give Open Authorization.
     */
    AUTHORIZATION_ERROR_WARNING = 'ASK_AI.AUTHORIZATION_ERROR_WARNING',
    /**
     * @value Connection succeeded. Reload to access all sources.
     * @description In the Ask AI Oauth flow: Message displayed when all sources that had an authorization error has been connected to.
     */
    AUTHORIZATION_SUCCESS_MESSAGE = 'ASK_AI.AUTHORIZATION_SUCCESS_MESSAGE',
    /**
     * @value Bad response
     */
    BAD_RESPONSE = 'ASK_LUMAPPS.BAD_RESPONSE',
    /**
     * @value Incorrect
     */
    FEEDBACK_REASON_INCORRECT = 'ASK_AI.FEEDBACK_REASON_INCORRECT',
    /**
     * @value Irrelevant
     */
    FEEDBACK_REASON_IRRELEVANT = 'ASK_AI.FEEDBACK_REASON_IRRELEVANT',
    /**
     * @value Feedback sent
     */
    FEEDBACK_SENT = 'ASK_AI.FEEDBACK_SENT',
    /**
     * @value Good response
     */
    GOOD_RESPONSE = 'ASK_AI.GOOD_RESPONSE',
    /**
     * @value How could this answer be improved?
     */
    HOW_CAN_ANSWER_BE_IMPROVED = 'ASK_AI.HOW_CAN_ANSWER_BE_IMPROVED',
    /**
     * @value How would you describe this answer?
     * @description Label of the ask ai feedback reason form.
     */
    HOW_DESCRIBE_ANSWER = 'ASK_AI.HOW_DESCRIBE_ANSWER',
    /**
     * @value Tips for a good prompt:
     */
    PROMPT_TIPS = 'WREX_AI.GENERATE_CONTENT_TIPS',
    /**
     * @value Add as many keywords as you can
     */
    PROMPT_TIPS_KEYWORDS = 'WREX_AI.GENERATE_CONTENT_TIPS_2',
    /**
     * @value Ask questions
     */
    PROMPT_TIPS_QUESTIONS = 'WREX_AI.GENERATE_CONTENT_TIPS_3',
}
